import { ParametrosPaginacao } from 'src/app/domain/primecap/model/interface/parametros-paginacao';
import { QuantidadeInvestidores } from './../model/quantidade-investidores';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InvestidorAssessorado } from '../model/investidor-assessorado';
import { ListaPaginada } from '../model/lista-paginada';
import { ComissaoPorRodada } from '../model/comissao-por-rodada';
import { InvestidoresAssessorRodada } from '../model/investidores-assessor-rodada';
import { RespostaHttp } from '../model/resposta-http';

@Injectable({
  providedIn: 'root'
})
export class DashboardAssessorCoreService {

  constructor(private http: HttpClient) { }

  getInvestidoresPorAssessor(assessorUuid: string,  paginacao: ParametrosPaginacao): Observable<RespostaHttp<ListaPaginada<InvestidorAssessorado>>> {
    let url = `${environment.apiUrl}/assessores/${assessorUuid}/dashboards/investidores`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`);
    } else {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http.get<RespostaHttp<ListaPaginada<InvestidorAssessorado>>>(url);
  }

  getComissoesPorRodada(assessorUuid: string, paginacao: ParametrosPaginacao): Observable<RespostaHttp  <ListaPaginada<ComissaoPorRodada>>> {
    let url = `${environment.apiUrl}/assessores/${assessorUuid}/dashboards/comissoes-por-rodada`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`);
    } else {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http.get<RespostaHttp <ListaPaginada<ComissaoPorRodada>>>(url);
  }

  getQuantidadeInvestidores(assessorUuid: string): Observable<RespostaHttp<QuantidadeInvestidores>> {
    return this.http.get<RespostaHttp<QuantidadeInvestidores>>(`${environment.apiUrl}/assessores/${assessorUuid}/dashboards/quantidade-investidores`)
  }

  getQuantidadeInvestidoresAtivos(assessorUuid: string): Observable<RespostaHttp<QuantidadeInvestidores>> {
    return this.http.get<RespostaHttp<QuantidadeInvestidores>>(`${environment.apiUrl}/assessores/${assessorUuid}/dashboards/quantidade-investidores-ativos`)
  }

  getInvestidoresDoAssessorNaRodada(assessorUuid: string, rodadaUuid: string, paginacao: ParametrosPaginacao): Observable<RespostaHttp<ListaPaginada<InvestidoresAssessorRodada>>> {
    let url = `${environment.apiUrl}/assessores/${assessorUuid}/dashboards/investidores/${rodadaUuid}`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`);
    } else {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http.get<RespostaHttp<ListaPaginada<InvestidoresAssessorRodada>>>(url);
  }
}
